// extracted by mini-css-extract-plugin
export default {"footer":"Footers_footer__TxOAm"};